<template>
  <div class="row responses mx-0 px-0 bg-white" id="chatMessageResponse">
    <div class="col-md-12 mx-0 px-0 pt-2" v-show="showErrorMessage">
      <div class="col mx-0 px-0 pr-5 text-right">
        <span class="error_message text-right"
          ><i class="fas fa-exclamation-circle mr-4"></i><span v-html="error">{{ error }}</span></span
        >
      </div>
    </div>

    <div class="col-md-12 mx-0 px-0 pb-2 animate fadeIn animate__delay-4s">
      <div class="chat-responses justify-content-center d-flex pt-2" id="chat-responses">
        <div v-if="chat_response.answer_type === 'selection'">
          <p class="chat_response_subheading text-center">
            {{ chat_response.data.subheading }}
          </p>
          <div class="d-flex justify-content-center flex-wrap">
            <div
              class="choice_box animate slideInUp delay-5s"
              :style="
                chat_response.data && chat_response.data.default === choice
                  ? 'background-color:#0CA8DA; color:#fff;'
                  : ''
              "
              v-for="(choice, i) in chat_response.data.options"
              :key="i"
               autofocus
              v-on:click="
                selectResponse(
                  choice,
                  chat_response.data.label,
                  chat_response.data.key
                )
              "
              :data-id="i"
            >
              {{ choice }}
            </div>
          </div>
        </div>

        <div v-else-if="chat_response.answer_type === 'selection_cover'">
          <p class="chat_response_subheading text-center">
            {{ chat_response.data.subheading }}
          </p>
          <div class="d-flex justify-content-between">
            <div
              class="choice_box animate slideInUp delay-5s"
              :style="
                chat_response.data.default === choice
                  ? 'background-color:#0CA8DA; color:#fff;'
                  : ''
              "
              v-for="(choice, i) in chat_response.data.options"
              :key="i"
               autofocus
              v-on:click="
                coverSelection(
                  choice,
                  chat_response.data.label,
                  chat_response.data.key
                )
              "
              :data-id="i"
            >
              {{ choice }}
            </div>
          </div>
        </div>

        <div v-else-if="chat_response.answer_type === 'selection_question'">
          <p
            class="chat_response_subheading text-center"
            v-if="chat_response.data.subheading"
          >
            {{ chat_response.data.subheading }}
          </p>
          <div class="d-flex justify-content-between">
            <div
              class="choice_box animate slideInUp delay-5s choice_box_blue"
              
              v-for="(choice, i) in chat_response.data.options"
              :key="i"
              autofocus
              v-on:click="
                questionAnswered(
                  choice,
                  chat_response.data.label,
                  chat_response.data.key,
                  chat_response.data.index,
                  chat_response.data.default
                )
              "
              :data-id="i"
            >
              {{ choice }}
            </div>
          </div>
        </div>

        <div
          v-else-if="chat_response.answer_type === 'search'"
          class="col mx-0 px-0"
          v-on:keyup.enter="
            typeResponse(chat_response.data.label, chat_response.data.key)
          "
        >
          <p
            class="chat_response_subheading text-center"
            v-if="chat_response.data.subheading"
          >
            {{ chat_response.data.subheading }}
          </p>
          <div class="d-flex justify-content-between p-2"   
              >
            <pli-select-chat-bot
              @select="searchSelected"
              @input="searchInput"
              v-model="inputValue"
              :options="searchOptions"
              :multiple="false"
              class="animate slideInUp delay-5s"
              track-by="id"
              ref="inputRef"
              :label="chat_response.data.selector"
              :placeholder="chat_response.data.help"
            />
            <!-- <div
                class="choice_box animate slideInUp delay-5s"
                v-for="(choice, i) in chat_response.data.options"
                :key="i"
                v-on:click="selectResponse(choice)"
                :data-id="i"
              >{{ choice }}</div> -->
            <div
              ref="searchSendButton"
              class="ml-2"
              v-on:click="
                typeResponse(chat_response.data.label, chat_response.data.key)
              "
            >
              <i class="fas fa-paper-plane fa-2x text-center pt-2"></i>
            </div>
          </div>
        </div>

        <div
          class="col mx-0 px-0"
          v-else-if="chat_response.answer_type == 'text'"
          v-on:keyup.enter="
            typeResponse(chat_response.data.label, chat_response.data.key)
          "
        >
          <p
            class="chat_response_subheading text-center"
            v-if="chat_response.data.subheading"
          >
            {{ chat_response.data.subheading }}
          </p>
          <div class="d-flex justify-content-between bg-white p-2">
            <input
              type="text"
              :placeholder="chat_response.data.help"
              class="form-control col d-flex"
              v-on:keyup.enter="
                typeResponse(chat_response.data.label, chat_response.data.key)
              "
              v-model="inputValue"
              autofocus
              required
              maxlength="200"
              ref="inputRef" 
              :style="showErrorMessage ? 'border:1px solid red' : ''"
            />
            <div
              class="ml-2"
              v-on:click="
                typeResponse(chat_response.data.label, chat_response.data.key)
              "
            >
              <i class="fas fa-paper-plane fa-2x text-center pt-2"></i>
            </div>
          </div>
        </div>

        <div
          class="col mx-0 px-0"
          v-else-if="chat_response.answer_type == 'email'"
          v-on:keyup.enter="
            typeResponse(chat_response.data.label, chat_response.data.key)
          "
        >
          <p
            class="chat_response_subheading text-center"
            v-if="chat_response.data.subheading"
          >
            {{ chat_response.data.subheading }}
          </p>
          <div class="d-flex justify-content-between bg-white p-2">
            <input
              type="email"
              :placeholder="chat_response.data.help"
              class="form-control col d-flex"
              v-on:keyup.enter="
                typeResponse(chat_response.data.label, chat_response.data.key)
              "
              v-model="inputValue"
                
              required
              ref="inputRef" 
              maxlength="200"
              :style="showErrorMessage ? 'border:1px solid red' : ''"
            />
            <div
              class="ml-2"
              v-on:click="
                typeResponse(chat_response.data.label, chat_response.data.key)
              "
            >
              <i class="fas fa-paper-plane fa-2x text-center pt-2"></i>
            </div>
          </div>
        </div>

        <div
          class="col mx-0 px-0"
          v-else-if="chat_response.answer_type == 'currency'"
          v-on:keyup.enter="
            typeResponse(chat_response.data.label, chat_response.data.key)
          "
        >
          <p
            class="chat_response_subheading text-center"
            v-if="chat_response.data.subheading"
          >
            {{ chat_response.data.subheading }}
          </p>
          <div class="d-flex justify-content-between bg-white p-2 input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">$</span>
            </div>
            <input
              type="number"
              step="10000"
              min="10000"
              max="10000000"
              :placeholder="chat_response.data.help"
              class="form-control col d-flex"
              v-on:keyup.enter="
                typeResponse(chat_response.data.label, chat_response.data.key)
              "
              v-model="inputValue"
              autofocus
              required
              ref="inputRef" 
              :style="showErrorMessage ? 'border:1px solid red' : ''"
            />
            <div class="input-group-append">
              <span class="input-group-text" style="border-top-right-radius:  0.25rem;
    border-bottom-right-radius: 0.25rem;">.00</span>
            </div>
            <div
              class="ml-2"
              v-on:click="
                typeResponse(chat_response.data.label, chat_response.data.key)
              "
            >
              <i class="fas fa-paper-plane fa-2x text-center pt-2"></i>
            </div>
          </div>
        </div>

        <div
          class="col mx-0 px-0"
          v-else-if="chat_response.answer_type == 'number'"
          v-on:keyup.enter="
            typeResponse(chat_response.data.label, chat_response.data.key)
          "
        >
          <p
            class="chat_response_subheading text-center"
            v-if="chat_response.data.subheading"
          >
            {{ chat_response.data.subheading }}
          </p>
          <div class="d-flex justify-content-between bg-white p-2">
            <input
              type="number"
              step="1"
              min="0"
              :placeholder="chat_response.data.help"
              class="form-control col d-flex"
              v-on:keyup.enter="
                typeResponse(chat_response.data.label, chat_response.data.key)
              "
              v-model="inputValue"
              autofocus
              ref="inputRef" 
              required
              :style="showErrorMessage ? 'border:1px solid red' : ''"
            />
            <div
              class="ml-2"
              v-on:click="
                typeResponse(chat_response.data.label, chat_response.data.key)
              "
            >
              <i class="fas fa-paper-plane fa-2x text-center pt-2"></i>
            </div>
          </div>
        </div>

        <div
          class="col mx-0 px-0"
          v-else-if="chat_response.answer_type == 'date'"
          v-on:keyup.enter="
            typeResponse(chat_response.data.label, chat_response.data.key)
          "
        >
          <p
            class="chat_response_subheading text-center"
            v-if="chat_response.data.subheading"
          >
            {{ chat_response.data.subheading }}
          </p>
          <div
            class="d-flex justify-content-between bg-white p-2"
            v-if="chat_response.data.key === 'dob'"
          >
            <date-pick
              :inputAttributes="{ placeholder: chat_response.data.help }"
              class="form-control col d-flex"
              v-on:keyup.enter="
                typeResponse(chat_response.data.label, chat_response.data.key)
              "
              autofocus
              required
              v-model="inputValue"
              :style="showErrorMessage ? 'border:1px solid red' : ''"
              :format="'DD/MM/YYYY'"
              :isDateDisabled="isDateDisabled"
              ref="inputRef" 
              :startPeriod="dobStartDate"
            ></date-pick>

            <div
              class="ml-2"
              v-on:click="
                typeResponse(chat_response.data.label, chat_response.data.key)
              "
            >
              <i class="fas fa-paper-plane fa-2x text-center pt-2"></i>
            </div>
          </div>
          <div class="d-flex justify-content-between bg-white p-2" v-else>
            <date-pick
              :inputAttributes="{ placeholder: chat_response.data.help }"
              class="form-control col d-flex"
              v-on:keyup.enter="
                typeResponse(chat_response.data.label, chat_response.data.key)
              "
              autofocus
              required
               ref="inputRef" 
              v-model="inputValue"
              :style="showErrorMessage ? 'border:1px solid red' : ''"
              :format="'DD/MM/YYYY'"
            ></date-pick>

            <div
              class="ml-2"
              v-on:click="
                typeResponse(chat_response.data.label, chat_response.data.key)
              "
            >
              <i class="fas fa-paper-plane fa-2x text-center pt-2"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 *  Import dependencies & event bus
 */
import store from "../../store";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import { EventBus } from "../../event-bus";
import Cookies from "js-cookie";
import * as appConfigs from "../../configs";
import axios from "axios";
import queryString, { parse } from "query-string";
import { includes } from "lodash";
import PliSelectChatBot from "../form/PliSelectChatBot";
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";

/**
 * Import local components
 */

export default {
  props: ["data", "inputRef"],
  store,
  components: { PliSelectChatBot, DatePick },
  data() {
    return {
      selected_index: null,
      error: "",
      showErrorMessage: false,
      chat_response: [],
      inputValue: null,
      search_selected: null,
      search_options: [],
    };
  },
  mounted() {
    this.initializeReminderToken();
    this.chat_response = this.data[0];
    if (this.chat_response.data !== undefined) {
      var typeOf = typeof this.chat_response.data;
      if (typeOf == "object") {
        this.chat_response.data = JSON.parse(
          JSON.stringify(this.chat_response.data)
        );
      } else {
        this.chat_response.data = JSON.parse(this.chat_response.data);
      }
    }

    this.$nextTick(() => {
      if(this.$refs.inputRef){
        // check whether it is a function or not 
        if(typeof this.$refs.inputRef.focus === "function" && !this.isMobileAndSearch){
          this.$refs.inputRef.focus();
        }else if(this.$refs.inputRef.$el && typeof this.$refs.inputRef.$el.focus === "function" && !this.isMobileAndSearch){
          this.$refs.inputRef.$el.focus();
        }
      }
    });
  },
  
  watch: {
    configs({ occupations }) {
      this.options = occupations;
    },
  },

  computed: {
    ...mapState({
      configs: (state) => state.configs,
      orderId: (state) => state.orderId, // 3026
      pendingOrder: (state) => state.pendingOrder,
      selectedOccupation: (state) => state.selectedOccupation,
      step: (state) => state.step,
      prevStep: (state) => state.prevStep,
      unavailableOccupations: (state) => state.unavailableOccupations,
      stateByPostcode: (state) => state.stateByPostcode,
    }),
    isMobileAndSearch() {
      return this.chat_response.answer_type === 'search' && this.$mq === "smobil";
    },
    searchOptions() {
      // If its hardcoded it will retrieve the data options, if not will retrieve from the api/system config
      if (this.chat_response.data.options_key === "system_occupations") {
        return this.configs.occupations;
      } else if (this.chat_response.data.options_key === "hardcoded") {
        return this.chat_response.data.options;
      }
    },
    showSidebar() {
      return this.step >= 5;
    },

    showInReferral() {
      return (
        Cookies.get("convertFromReferral") != this.pendingOrder.id &&
        this.pendingOrder.in_referral
      );
    },

    showUnavailableOccupation() {
      if (
        this.step >= 3 &&
        this.prevStep >= 2 &&
        (includes(
          this.unavailableOccupations,
          this.pendingOrder.occupation_id
        ) ||
          this.pendingOrder.current_annual_revenue > 2500000 ||
          this.pendingOrder.status == "HS")
      ) {
        // Cleaning the pendingOrderId because
        // after the thank you page, user should be able to fill out the form again
        Cookies.remove("pendingOrderId");
        return true;
      }
      return false;
    },
    dobStartDate(date) {
      let currentDate = new Date();
      let currentYear = currentDate.getFullYear();
      return { month: currentDate.getMonth(), year: currentYear - 18 };
    },
  },

  methods: {
    ...mapMutations({
      toggleShowEmailBlock: "toggleShowEmailBlock",
      setAgreedToTerms: "setAgreedToTerms",
      updateExistingPendingOrderId: "updateExistingPendingOrderId",
      updateSelectedOccupation: "updateSelectedOccupation",
      setAgreedToDeclaration: "setAgreedToDeclaration",
      updateStateByPostcode: "updateStateByPostcode",
    }),

    //check if reminder token exists, if it is then need to fire an ajax request to
    //check if the token is valid, then set the cookie, otherwise no further action
    //needed to be taken
    initializeReminderToken() {
      let vm = this;
      let queryStringObj = queryString.parse(location.search);
      if ("reminder_token" in queryStringObj) {
        //if any error/exception occur, do not need to do anything, so axios do not need
        //catch to handle error
        axios
          .get(appConfigs.decryptReminderTokenUrl, {
            params: queryStringObj,
          })
          .then((response) => {
            if (response.data.status == "error") {
              Cookies.remove("pendingOrderId");
              vm.$store.commit("setError", { error: response.data.message });
            } else if (response.data.status == "success") {
              Cookies.set("pendingOrderId", response.data.pending_order_id);
            }
          })
          .catch((error) => {
            Cookies.remove("pendingOrderId");
            vm.$store.commit("setError", { error: "Invalid token error" });
          });
      }
    },

    selectResponse(choice, label, key) {
      // this.selected_index = index;

      if (choice === null || choice == "" || choice.length === 0) {
        this.error = "Sorry, looks like you haven't selected an option.";
        this.showErrorMessage = true;
        return;
      }

      var response = choice;
      if (label !== undefined) {
        var field_key = label.trim().toLowerCase().replace(/\s+/g, "_");
        response = { label: field_key, data: choice, key };
      }

      this.$emit("selectedUserResponse", response);
    },
    coverSelection(choice, label, key) {
      // this.selected_index = index;
      if (choice === null || choice == "" || choice.length === 0) {
        this.error = "Sorry, looks like you haven't selected an option.";
        this.showErrorMessage = true;
        return;
      }

      var response = choice;
      if (label !== undefined) {
        var field_key = label.trim().toLowerCase().replace(/\s+/g, "_");
        response = { label: field_key, data: choice, key };
      }

      this.$emit("coverSelection", response);
    },
    questionAnswered(choice, label, key, index, is_default) {
      if (choice === null || choice == "" || choice.length === 0) {
        this.error = "Sorry, you need to answer the questions.";
        this.showErrorMessage = true;
        return;
      }

      var response = choice;
      if (label !== undefined) {
        var field_key = label.trim().toLowerCase().replace(/\s+/g, "_");
        response = { label: field_key, data: choice, key, index, is_default };
      }

      this.$emit("questionAnswered", response);
    },
    searchSelected(select) {
      if (select.id) {
        this.inputValue = select.id;
      }
      // this.$refs.searchSendButton.click();
    },

    searchInput(value, id){
      this.$refs.searchSendButton.click();
    },
   
    async typeResponse(label, key) {
      var data = this.inputValue;

      var field_key = label.trim().toLowerCase().replace(/\s+/g, "_");

      if (data === null || data == "" || data.length === 0) {
        this.error = "Oops, You need to enter a value to continue.";
        this.showErrorMessage = true;
        return;
      }

    // name validation
      if (field_key == "full_name" || field_key == "name") {
        var re = /^([A-Za-z ]+)$/;
        if (!re.test(data)) {
          this.error = "Sorry, it appears to be an invalid name.";
          this.showErrorMessage = true;
          return;
        } else if (data) {
          var fullName = data.split(" ");
          if (fullName.length < 2) {
            this.error = "Sorry, you need to enter your first and last name.";
            this.showErrorMessage = true;
            return;
          } else if (fullName[1].length < 2) {
            this.error = "Sorry, you need to enter your first and last name.";
            this.showErrorMessage = true;
            return;
          } else {
            this.error = "";
            this.showErrorMessage = false;
          }
        } else {
          this.error = "";
          this.showErrorMessage = false;
        }
      }

      // occupation validaiton
      if (field_key == "occupation" && typeof data == "string") {
        var re = /^([A-Za-z 0-9]+)$/;
        if (!re.test(data)) {
          this.error = "Oops, the occupation seams to be invalid.";
          this.showErrorMessage = true;
          return;
        } else {
          this.error = "";
          this.showErrorMessage = false;
        }
      }

       // date validaiton
      if (field_key == "dob" && typeof data == "date_of_birth") {
        var re = /^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/]\d{4}$/;
        if (!re.test(data)) {
          this.error = "Oops, the date appears to be a different format. It should be dd/mm/yyyy";
          this.showErrorMessage = true;
          return;
        } else {
          this.error = "";
          this.showErrorMessage = false;
        }
      }

      // email validaiton
      if (field_key == "email") {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(data)) {
          this.error = "Oops, the email appears to be not valid.";
          this.showErrorMessage = true;
          return;
        } else {
          this.error = "";
          this.showErrorMessage = false;
        }
      }

      // phone number validation
      if (
        field_key == "phone" ||
        field_key == "phone_number" ||
        field_key == "mobile_number"
      ) {
        var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
        if (!re.test(data)) {
          this.error = "Oops, the phone number you entered is not valid.";
          this.showErrorMessage = true;
          return;
        } else if (data && data.toString().length < 10) {
          this.error = "Oops, the phone number you entered is not valid.";
          this.showErrorMessage = true;
          return;
        } else {
          this.error = "";
          this.showErrorMessage = false;
        }
      }

      // turnover validation
      if (field_key == "turnover" || field_key == "annual_revenue") {
        if (data && parseInt(data) < 1000) {
          this.error = "The turnover appears to be not valid.";
          this.showErrorMessage = true;
          return;
        } else if (data && parseInt(data) > 10000000) {
          this.error = "Sorry, we are unable to provide an online quote for the turnover value. Please contact us for a custom quote Thank you.";
          this.showErrorMessage = true;
          return;
        } else {
          this.error = "";
          this.showErrorMessage = false;
        }
      }

      // number of staff validation
      if (field_key == "number_of_staff" || field_key == "head_count") {
        if (data && (parseInt(data) <= 0 || parseInt(data) > 10)) {
          this.error =
            "Sorry, the online quote is unavailable for the selected number of staff.";
          this.showErrorMessage = true;
          return;
        } else {
          this.error = "";
          this.showErrorMessage = false;
        }
      }

      // number of staff validation
      if (field_key == "heat_work_percentage" ) {

        if (data && data.id && data.id == ">5") {
          this.error =
            "Online quote unavailable for the selected heat work percentage. Please contact <a href='tel:1300542245'>1300 542 245</a> to proceed.";
          this.showErrorMessage = true;
          return;
        } else {
          this.error = "";
          this.showErrorMessage = false;
        }
      }

      // postcode validation
      if (field_key == "postcode" || field_key == "postcode_of_risk") {
        if (data && (parseInt(data) < 800 || parseInt(data) > 7471) ) {
          this.error = "The postcode is invalid.";
          this.showErrorMessage = true;
          return;
        } else {
          var postCodeCheck = await this.postCodeChanged(data);
          if(!this.stateByPostcode){
            this.error = "Sorry, we don't cover the postcode you entered. Please contact <a href='tel:1300542245'>1300 542 245</a> to proceed.";
            this.showErrorMessage = true;
            return;
          } else if(postCodeCheck && this.stateByPostcode) {
            this.error = "";
            this.showErrorMessage = false;
          } 
        } 
      }

      //
      if (
        field_key == "accident_cover_individual" ||
        field_key == "name_of_insured_individual"
      ) {
        var re = /^([A-Za-z ]+)$/;
        if (!re.test(data)) {
          this.error = "Sorry, the name of the insured appears to be invalid.";
          this.showErrorMessage = true;
          return;
        } else {
          this.error = "";
          this.showErrorMessage = false;
        }
      }


      var response = { label: field_key, data: data, key };
      this.showErrorMessage = false;
      this.$emit("selectedUserResponse", response);
    },

    async postCodeChanged(postcode) {
      var state = null;
      await axios
        .post(appConfigs.checkPostCodeUrl, {
          postcode_of_risk: postcode,
        })
        .then((response) => {
          state = response.data.state;
          this.updateStateByPostcode({ stateByPostcode: state });
        })
        .catch((error) => {
          state = null;
        });

      if (state === null) {
        return false;
      } else {
        return true;
      }
    },

    isDateDisabled(date) {
      let currentDate = new Date();
      let currentYear = currentDate.getFullYear();
      let allowedYear = new Date(
        currentYear - 18,
        currentDate.getMonth(),
        currentDate.getDate()
      );

      return date > allowedYear;
    },
  },
};
</script>

<style>
.responses {
  padding: 0 20px;
}
.chat-responses {
  background-color: #fff;
  width: 100%;
}
.form-control {
  background-color: #fff;
  height: 50px !important;
  font-size: 16px;
}
@media screen and (max-width: 768px) {
  .form-control {
    font-size: 14px;
  }
}
.form-control:focus {
  border-color: #009245 !important;
}
.chat_response_subheading {
  color: #888;
  margin-bottom: 0px;
}

@media screen and (max-width: 768px) {
  .choice_box {
    width: 40% !important;
    margin: 2px !important;
    padding: 5px !important;
  }
}
#chatMessageResponse {
  bottom: 0;
  width: 100%;
}
.choice_box {
  background-color: #dedede;
  padding: 10px;
  color: #000;
  margin-top: 3px;
  border-radius: 5px;
  margin: 10px;
  cursor: pointer;
  min-width: 150px;
  width: auto;
  max-width: 220px;
  text-align: center;
  transition: all 0.5s ease;
  text-transform: capitalize;
  align-items: center !important;
  justify-content: center !important;
  display: flex !important;
}

.choice_box:hover {
  background-color: #009245;
  color: #fff;
}
.choice_box_blue{
   background-color: #0CA8DA !important;
    color: #fff;
}

.choice_box_blue:hover{
   background-color: #009245 !important;
}

.fa-paper-plane {
  color: #0ca8da;
  cursor: pointer;
}
.fa-paper-plane:hover {
  color: #009245;
}
.error_message {
  color: rgb(168, 0, 0) !important;
  padding-bottom: 20px !important;
}
.vdpComponent {
  padding: 0px !important;
  font-size: 12px !important;
}
.vdpComponent input {
  width: 100% !important;
  background-color: #fff !important;
  border: medium none !important;
  border-radius: 4px !important;
  color: #66615b !important;
  font-size: 16px !important;
  transition: background-color 0.3s ease 0s !important;
  padding: 7px 18px !important;
  height: 40px !important;
  box-shadow: none !important;
}
.vdpArrowPrev:after {
  border-right-color: #009245;
}

.vdpArrowNext:after {
  border-left-color: #009245;
}

.vdpCell.selectable:hover .vdpCellContent,
.vdpCell.selected .vdpCellContent {
  background: #009245;
}

.vdpCell.today {
  color: #009245;
}

.vdpRow .disabled{
    color: #fff !important;
    display:table-cell !important;
}

.vdpTimeUnit > input:hover,
.vdpTimeUnit > input:focus {
  border-bottom-color: #009245;
}
</style>
    